import apiClient from '@/services/api/client'

const PATH = '/api/v1/ai-quota'

export type AiProviderMode = 'managed' | 'byok'
export type AiQuotaStatus = 'ok' | 'low' | 'empty' | 'byok' | 'unavailable' | 'provider_missing'
export type AiCreditProductType = 'ai_credit_reload' | 'ai_subscription_package'

export interface AiCreditProduct {
  productConfigId: number
  productType: AiCreditProductType
  code: string
  title: string
  version: string
  credits: number
  expiresAfterDays: number
  billingCycle: 'monthly' | string | null
  pricing: {
    currency: string
    oneTimeFeeCents: number | null
    monthlyFeeCents: number | null
  }
}

export interface AiQuotaSummary {
  actionPricing?: Record<'standard' | 'image', { credits: number; maximum: boolean }>
  ownKeyConfigured?: boolean
  providerMode: AiProviderMode
  quotaApplies: boolean
  status: AiQuotaStatus
  message?: string
  periodStart: string | null
  periodEnd: string | null
  includedCredits: number
  usedCredits: number
  remainingCredits: number | null
  reloadCredits: number
  nextResetAt: string | null
  lastFreeReset: {
    occurredAt: string | null
    creditsGranted: number
    periodStart: string | null
    periodEnd: string | null
    reason: string | null
  } | null
  availableReloadProducts: AiCreditProduct[]
  availablePackageProducts: AiCreditProduct[]
}

export interface AiCreditCheckoutRequest {
  productType: AiCreditProductType
  code: string
  successUrl?: string
  cancelUrl?: string
}

export interface AiCreditCheckoutResponse {
  url: string
  sessionId: string
  stripeMode: 'sandbox' | 'live'
  paymentProvider: 'stripe'
  status: 'requires_payment'
}

export const aiQuotaApi = {
  async getSummary(): Promise<AiQuotaSummary> {
    const { data } = await apiClient.get<AiQuotaSummary>(PATH)
    return data
  },

  async createCheckout(payload: AiCreditCheckoutRequest): Promise<AiCreditCheckoutResponse> {
    const { data } = await apiClient.post<AiCreditCheckoutResponse>(`${PATH}/checkout`, payload)
    return data
  },
}
